import type { Auth0UserLike, RegionalUserLike } from '../../types/auth0-user.type'

import { getEmailLocalPart } from './getEmailLocalPart'
import { getFullName } from './getFullName'
import { getProfileValue } from './getProfileValue'
import { isEmailLike } from './isEmailLike'
import { normalizeValue } from './normalizeValue'

export const getLastName = (
  auth0User: Auth0UserLike,
  firstName: string,
  regionalData?: RegionalUserLike | null
): string => {
  const { lastName } = getFullName(auth0User)
  const email = getProfileValue(auth0User.profile?.email, auth0User.email)
  const emailLocalPart = getEmailLocalPart(email)
  const candidateLastName =
    normalizeValue(regionalData?.lastname) ||
    getProfileValue(auth0User.profile?.family_name, auth0User.family_name) ||
    lastName

  if (isEmailLike(firstName) || candidateLastName === emailLocalPart) {
    return ''
  }

  return candidateLastName
}
